export default {
  darkBlue: '#2c3e50',
  darkBlue2: '#00000030',
  darkBlue3: '#00000080',
  grey: '#424242',
}
